import React from "react";
import { i18n } from "../../translate/i18n";
import MasterModal from "./MasterModal";
import { formatContractDueDate } from "../../helpers/formatContractDueDate";
import { formatContractValue } from "../../helpers/formatContractValue";

export default function ContractDetailsModal({ company, onClose }) {
	if (!company) return null;

	const details = company.contractDetails?.trim() || "";

	return (
		<MasterModal
			open={!!company}
			onClose={onClose}
			title={i18n.t("master.pages.contractDetailsLabel")}
			subtitle={company.name || "—"}
			maxWidth={640}
		>
			<div className="mb-4 flex flex-wrap gap-6 text-sm">
				<div>
					<p className="text-xs font-semibold uppercase tracking-wide text-default-500 m-0 mb-1">
						{i18n.t("master.pages.contractValueLabel")}
					</p>
					<p className="text-default-800 dark:text-default-100 m-0 font-semibold">
						{formatContractValue(company.contractValue)}
					</p>
				</div>
				<div>
					<p className="text-xs font-semibold uppercase tracking-wide text-default-500 m-0 mb-1">
						{i18n.t("master.pages.contractDueDateLabel")}
					</p>
					<p className="text-default-800 dark:text-default-100 m-0 font-medium">
						{formatContractDueDate(company.contractDueDate)}
					</p>
				</div>
			</div>

			<div className="rounded-lg border border-default-200 bg-default-50 p-4 dark:border-default-600 dark:bg-default-800/50">
				<p className="text-xs font-semibold uppercase tracking-wide text-default-500 m-0 mb-2">
					{i18n.t("master.pages.contractDetailsReadOnlyLabel")}
				</p>
				{details ? (
					<div className="text-sm text-default-800 dark:text-default-100 whitespace-pre-wrap break-words leading-relaxed select-text">
						{details}
					</div>
				) : (
					<p className="text-sm text-default-500 m-0 italic">
						{i18n.t("master.pages.noContractDetails")}
					</p>
				)}
			</div>
		</MasterModal>
	);
}
